module.exports = __webpack_public_path__ + "img/xunta_white_logo.f0f7a474.png";